import React from 'react';
import BillCollectListContainer from '../../containers/billcollect/BillCollectListContainer';

const BillCollectListPage = () => {
  return <BillCollectListContainer />;
};

export default BillCollectListPage;
